export enum ApiTestRoutes {
  index = 'apiTest-index',
  imageAnalysis = 'apiTest-imageAnalysis'
}
